import TenderCard from './TenderCard';

export default TenderCard;
